module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Login"
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent,
      "activeTo": "Home"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Login_main"
  }, [_c('div', {
    staticClass: "Login-page-content"
  }, [_c('div', {
    staticClass: "Login_page"
  }, [_c('div', {
    staticClass: "log-reg-main"
  }, [_c('img', {
    staticClass: "ifree-logo",
    attrs: {
      "src": require("../../assets/home/new_home/logo_blue@2x.png")
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "login-title"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('user_center_already_account')) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "login-main"
  }, [_c('div', {
    staticClass: "from-input"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.account),
      expression: "loginData.account"
    }],
    staticClass: "login-email",
    class: {
      'is-error': _vm.errors.has('email')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('user_center_email'),
      "name": "email"
    },
    domProps: {
      "value": (_vm.loginData.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginData, "account", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "from-input",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.loginData.password),
      expression: "loginData.password"
    }],
    staticClass: "login-password",
    class: {
      'is-error': _vm.errors.has('password')
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('user_center_password'),
      "name": "password"
    },
    domProps: {
      "value": (_vm.loginData.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginData, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.showthis_1 === 'a') ? _c('img', {
    staticStyle: {
      "position": "absolute",
      "right": "10px",
      "top": "25px"
    },
    attrs: {
      "src": require("../../assets/icon_eye.png"),
      "width": "30"
    },
    on: {
      "click": function($event) {
        _vm.hide()
      }
    }
  }) : (_vm.showthis_1 === 'b') ? _c('img', {
    staticStyle: {
      "position": "absolute",
      "right": "10px",
      "top": "25px"
    },
    attrs: {
      "src": require("../../assets/icon_hide.png"),
      "width": "30"
    },
    on: {
      "click": function($event) {
        _vm.show()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "forget-psw"
  }, [_c('a', {
    on: {
      "click": _vm.forget_psw
    }
  }, [_vm._v(_vm._s(_vm.$t('user_center_forget_password')))])]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px",
      "color": "#5E6D82",
      "text-align": "left"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('login_agree')) + "\n                                "), _c('router-link', {
    staticClass: "text-primary",
    attrs: {
      "to": {
        name: 'terms_of_service'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('agree_terms_of_conditions')))]), _vm._v(",\n                                    "), _c('router-link', {
    staticClass: "text-primary",
    attrs: {
      "to": {
        name: 'privacy_policy'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('agree_privacy_policy')) + "\n                                ")]), _vm._v("\n                                " + _vm._s(_vm.$t('and')) + "\n                                "), _c('router-link', {
    staticClass: "text-primary",
    attrs: {
      "to": {
        name: 'terms_of_law'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('agree_terms_of_law')))]), _vm._v(".\n                            ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "login-register-btn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('user_center_login')) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "Option-group"
  }, [_c('div', {
    staticClass: "Option-part-one"
  }, [_c('div', {
    staticClass: "FB-icon"
  }, [_c('a', [_c('img', {
    attrs: {
      "src": require("../../assets/facebook_c.png"),
      "width": "50"
    },
    on: {
      "click": _vm.fblogin
    }
  })])]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('login_disan')))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('a', [_c('router-link', {
    staticClass: "text-primary",
    attrs: {
      "to": {
        name: 'Register'
      }
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('login_tip')))])])], 1)])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "WC-icon"
  }, [_c('a', {
    attrs: {
      "href": "http://officialapi.ifreegroup.co/wxlogin"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/wechat_c.png"),
      "width": "50"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d5fea44","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Login.vue
// module id = 791
// module chunks = 0